import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {EnvironmentService} from '../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {WebsitePage} from '../../models/website-page';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

declare var $: any;
declare var Snackbar: any;

// noinspection DuplicatedCode
@Component({
  selector: 'app-website-pages',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './website-pages.component.html',
  styleUrls: ['./website-pages.component.scss']
})
export class WebsitePagesComponent implements OnInit {

  websitePages: WebsitePage[];
  subAccountType: any;
  subAccountGovId: any;
  loading: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  lang: string;

  checkPermission() {
    this.route.queryParams.subscribe(params => {
      let perms = this.env.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isMerchant = perms.isMerchant;
      this.isManager = perms.isManager;

      console.log('sales', this.isSales);
      console.log('is merchant', this.isMerchant);
      console.log('is manager', this.isManager);
    });
  }

  constructor(private loader: GlobalLoaderService,
              public env: EnvironmentService,
              private translator: TranslateService,
              private router: Router,
              private route: ActivatedRoute,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.lang = await firstValueFrom(this.translator.get('lang'));
    await this.loadResources();
    await this.loadData();
    this.loading = false;
    this.checkPermission();
  }

  async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    setInterval(() => {
      $('.dropdown-toggle2').dropdown();
    }, 1000);
  }

  async deleteWebsitePage(websitePageId, websitePageTitle) {
    let response: any = await this.api.postDeleteWebsitePage(websitePageId);

    if (response && response == 200) {
      let websitePageLabel = await firstValueFrom(this.translator.get('The websitePage'));
      let deleteText = await firstValueFrom(this.translator.get('successfully deleted'));
      await this.loadData();
      Snackbar.show({
        text: websitePageLabel + ' ' + websitePageTitle + ' ' + deleteText,
        pos: 'bottom-center'
      });
    }
  }

  private static compare(a, b) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
    return 0;
  }

  private async loadData() {
    this.websitePages = await this.api.loadWebsitePages();
    console.log('websitePages', this.websitePages);
    this.websitePages.sort(WebsitePagesComponent.compare);
  }
}
